import { createContext } from "react";
import { localeText as defaultLocaleText } from "../../localeText.js";
const defaultState = {
  localeText: defaultLocaleText,
  allowNoColor: false,
  allowRandomColor: true,
  swatchesPerRow: 8,
  maxRowsBeforeScrolling: 6,
  customColors: "none",
  placeholderMode: "one-at-time",
  autoCommit: false,
  selection: /* @__PURE__ */ new Set(),
  value: "#fff",
  color: "#fff",
  swatchSize: 24,
  swatchesGap: 1,
  onChange: () => void 0,
  onAddColor: () => void 0,
  onDiscardLocalChanges: () => void 0,
  onDeleteColor: () => void 0,
  onInvalidColor: () => void 0,
  onChangeSelection: () => void 0,
  router: { route: { id: "palette" } },
  goToAddColorToPalette: () => void 0,
  goToCustom: () => void 0,
  goToPalette: () => void 0,
  navigate: () => void 0,
  onCommit: () => void 0,
  onCancel: () => void 0
};
const colorPickerContext = createContext(defaultState);
export {
  colorPickerContext,
  defaultState
};
//# sourceMappingURL=context.js.map
